import { ENUM_AdvisorUserPermissionLevel } from '@api-new/common';
import { HTTP_AP_ListReferrals_Request_Sort } from '@api-new/userservice';
import { ReferralCodeTableFilterModel } from '@platform/referral-code/models/referral-code-table-filter.model';
import { ReferralCodeTableRowModel } from '@platform/referral-code/models/referral-code-table.model';
import { RowDefinitionTypeEnum } from '@shared/components/table/enums/row-definition-type.enum';
import { TableRowDefinitionModel } from '@shared/components/table/models/table-row-definition.model';
import { PermissionEnum } from '@shared/enums/permission.enum';
import { HasCurrentUserRequiredPermissionsFunctionModel } from '@shared/services/permission.service';

export const referralCodeTableFilterDefaults: ReferralCodeTableFilterModel = {
  codeContains: '',
  assignToAdvisorUserIds: [],
  networkIds: [],
  assignToCompanyIds: [],
  referredByAffiliateIds: [],
  nameOrDescription: '',
  createdAt: null,
  isActive: null,
};

export const referralCodeTableRowDefinition = (
  hasCurrentUserRequiredPermissions: HasCurrentUserRequiredPermissionsFunctionModel,
): TableRowDefinitionModel<ReferralCodeTableRowModel, HTTP_AP_ListReferrals_Request_Sort>[] => {
  return [
    {
      columnLabel: 'Name',
      sortKey: 'byName',
      columnKey: 'name',
      type: RowDefinitionTypeEnum.Text,
      width: {
        min: '240px',
        max: '240px',
      },
      isFrozen: true,
    },
    {
      columnLabel: 'Company',
      sortKey: 'byCompanyTradingName',
      columnKey: 'companyName',
      type: RowDefinitionTypeEnum.Text,
      isHidden: !hasCurrentUserRequiredPermissions([
        {
          permission: PermissionEnum.ReferralRead,
          permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_COMPANY,
        },
      ]),
      width: {
        min: '200px',
        max: '200px',
      },
    },
    {
      columnLabel: 'Adviser',
      sortKey: 'byAdvisorUserDisplayName',
      columnKey: 'adviserName',
      type: RowDefinitionTypeEnum.Text,
      isHidden: !hasCurrentUserRequiredPermissions([
        {
          permission: PermissionEnum.ReferralRead,
          permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_DIRECT,
        },
      ]),
      width: {
        min: '120px',
        max: '120px',
      },
    },
    {
      columnLabel: 'Affiliate',
      sortKey: 'byAffiliateName',
      columnKey: 'affiliateName',
      type: RowDefinitionTypeEnum.Text,
      width: {
        min: '120px',
        max: '120px',
      },
    },
    {
      columnLabel: 'Created',
      columnKey: 'createdAt',
      sortKey: 'byCreatedAt',
      type: RowDefinitionTypeEnum.Date,
      width: {
        min: '100px',
        max: '100px',
      },
    },
    {
      columnLabel: 'Clicks',
      columnKey: 'referralClicksCount',
      sortKey: 'byClicksCount',
      type: RowDefinitionTypeEnum.Number,
      width: {
        min: '70px',
        max: '90px',
      },
    },
    {
      columnLabel: 'Status',
      columnKey: 'isActive',
      sortKey: 'byIsActive',
      type: RowDefinitionTypeEnum.BinaryStatus,
      width: {
        min: '120px',
        max: '120px',
      },
    },
    {
      columnLabel: 'Code',
      columnKey: 'code',
      type: RowDefinitionTypeEnum.Text,
      width: {
        min: '250px',
        max: '250px',
      },
    },
  ];
};
